import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {NgClass} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {RouterModule} from '@angular/router';
import {MenuModel} from './menu.model';
import {MatBadgeModule} from '@angular/material/badge';

@Component({
  imports: [MatIconModule, RouterModule, NgClass, MatBadgeModule],
  selector: 'oct-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent {
  /** Whether the menu items and icons should be hidden. */
  isVisible = input<boolean>(true);

  /** the user input data for rendering menu */
  data = input<MenuModel[]>([]);

  /** Emits when user click on menu item */
  menuChangeEmit = output<MenuModel | true>();
}
